export const translations = {
  en: {
    appTitle: 'iRecruteur',
    uploadResumes: 'Upload Resumes',
    processing: 'Processing...',
    resumesUploaded: 'resume(s) uploaded',
    jobRequirements: 'Job Requirements',
    jobTitle: 'Job Title',
    jobDescription: 'Job Description',
    requiredSkills: 'Required Skills (comma-separated)',
    requiredQualifications: 'Required Qualifications (comma-separated)',
    minimumExperience: 'Minimum Years of Experience',
    saveRequirements: 'Save Job Requirements',
    analyzeButton: 'Analyze Candidates',
    analyzingButton: 'Analyzing Candidates...',
    uploadToAnalyze: 'Upload resumes to analyze',
    enterJobRequirements: 'Enter job requirements to analyze',
    processingFiles: 'Processing files...',
    analysisInProgress: 'Analysis in progress...',
    candidateRankings: 'Candidate Rankings',
    analyzing: 'Analyzing...',
    clickToAnalyze: 'Click "Analyze Candidates" above to see candidate rankings',
    loadingTitle: 'AI is analyzing your candidates',
    loadingSubtext: 'Finding the best matches based on skills, experience, and qualifications...',
  },
  fr: {
    appTitle: 'iRecruteur',
    uploadResumes: 'Télécharger les CV',
    processing: 'Traitement en cours...',
    resumesUploaded: 'CV téléchargé(s)',
    jobRequirements: 'Exigences du poste',
    jobTitle: 'Titre du poste',
    jobDescription: 'Description du poste',
    requiredSkills: 'Compétences requises (séparées par des virgules)',
    requiredQualifications: 'Qualifications requises (séparées par des virgules)',
    minimumExperience: 'Années d\'expérience minimales',
    saveRequirements: 'Enregistrer les exigences',
    analyzeButton: 'Analyser les candidats',
    analyzingButton: 'Analyse en cours...',
    uploadToAnalyze: 'Téléchargez des CV pour analyser',
    enterJobRequirements: 'Entrez les exigences du poste pour analyser',
    processingFiles: 'Traitement des fichiers...',
    analysisInProgress: 'Analyse en cours...',
    candidateRankings: 'Classement des candidats',
    analyzing: 'Analyse en cours...',
    clickToAnalyze: 'Cliquez sur "Analyser les candidats" ci-dessus pour voir le classement',
    loadingTitle: 'L\'IA analyse vos candidats',
    loadingSubtext: 'Recherche des meilleures correspondances basées sur les compétences, l\'expérience et les qualifications...',
  }
} as const;

export type Language = keyof typeof translations;
export type TranslationKey = keyof typeof translations.en; 